"use strict";
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCard = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var React = tslib_1.__importStar(require("react"));
var common_1 = require("../../common");
var props_1 = require("../../common/props");
/**
 * Section card component.
 *
 * @see https://blueprintjs.com/docs/#core/components/section.section-card
 */
exports.SectionCard = React.forwardRef(function (props, ref) {
    var _a;
    var className = props.className, children = props.children, _b = props.padded, padded = _b === void 0 ? true : _b, htmlProps = tslib_1.__rest(props, ["className", "children", "padded"]);
    var classes = (0, classnames_1.default)(common_1.Classes.SECTION_CARD, (_a = {}, _a[common_1.Classes.PADDED] = padded, _a), className);
    return (React.createElement("div", tslib_1.__assign({ className: classes, ref: ref }, htmlProps), children));
});
exports.SectionCard.displayName = "".concat(props_1.DISPLAYNAME_PREFIX, ".SectionCard");
//# sourceMappingURL=sectionCard.js.map